
import { mapGetters } from "vuex";

export default {
  data: () => ({
    obs: "",
    dialog: false,
    infoDialog: false,
    info: {},

    snackbar: false,
    snackbarMensagem: "",
    snackbarCor: "success",
    salvando: false,
  }),

  computed: {
    locais() {
      return [];
    },

    modo() {
      return this.$route.query.modo;
    },

    ...mapGetters("usuario", {
      usuario: "getUsuario",
    }),

    historicoOrdenado() {
      return [...this.historico].sort((a, b) => {
        return (
          new Date(b.data.replace(" ", "T")) -
          new Date(a.data.replace(" ", "T"))
        );
      });
    },
  },

  props: {
    historico: {
      type: Array,
      default: () => [],
    },

    id: Number,
    status: String,
  },

  methods: {
    adicionarNota() {
      this.salvando = true;

      this.$http
        .put(`/venda/status/${this.id}`, {
          obs: this.obs,
          status: this.status,
          userID: this.usuario.id,
          userName: this.usuario.nome,
        })
        .then(() => {
          this.obs = "";
          this.dialog = false;

          this.snackbarCor = "success";
          this.snackbarMensagem = "Nota registrada com sucesso.";
          this.snackbar = true;

          this.$emit("change");
        })
        .catch(() => {
          this.snackbarCor = "error";
          this.snackbarMensagem = "Não foi possível registrar a nota.";
          this.snackbar = true;
        })
        .finally(() => {
          this.salvando = false;
        });
    },

    infoNota(id) {
      const nota = this.historico.find((item) => item.id === id);

      if (!nota) {
        return;
      }

      this.info = nota;
      this.infoDialog = true;
    },
  },

  filters: {
    dataFormatada(value) {
      if (!value) {
        return "erro na data";
      }

      const data = value.split("T")[0].split(" ")[0];
      const partes = data.split("-");

      if (partes.length !== 3) {
        return "erro na data";
      }

      const [ano, mes, dia] = partes;

      return `${dia}/${mes}/${ano}`;
    },

    horaFormatada(value) {
      if (!value) {
        return "";
      }

      const partes = value.includes("T") ? value.split("T") : value.split(" ");

      if (!partes[1]) {
        return "";
      }

      return partes[1].split(".")[0];
    },
  },
};
